// src/entities/BaseEntity.js
export class BaseEntity {
    constructor() {
    }

    entityName = "";
    pageTitle = "";
    menuPath = "";
    fields = [];
    pages = {};

    getVisibleFields() {
        return this.fields.filter(f => f.visible !== false);
    }

    getEditableFields() {
        return this.fields.filter(f => f.editable !== false);
    }

    getAdvancedFilterFields(fieldsToUse = null) {
        return fieldsToUse ? this?.[fieldsToUse] : this.pages.list.filters.advanced.fields
    }

    getFieldLabel(key) {
        const field = this.fields.find(f => f.key === key);
        return field ? field.label : key;
    }

    getDefaultValues() {
        const values = {};
        this.fields.forEach(f => values[f.key] = "");
        return values;
    }

    getDefaultValuesFields() {
        const values = {};
        this.pages.list.filters.advanced.fields.forEach(f => values[f.key] = "");
        return values;
    }

    getKeysWithDefaultValues() {
        return this.fields
            .filter(field =>
                Array.isArray(field.options) &&
                field.options.some(opt => opt.default === true)
            )
            .map(field => field.key);
    }

}
